import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { CreateSimulacaoService } from '@/features/simulador/brasil/http/create-simulacao.service'
import type { TSalvarSimulacaoBody } from '@/features/simulador/brasil/types/simulacao.type'
import { showToast } from '@/infra/sonner'
import type { TGetSimulacaoProdutoResponse } from '@/types/simulacao'
import { simulacaoKeys } from '@/utils/simulador-queries'

export const useMutationSalvarSimulacao = (onSuccess?: (simulacao: TGetSimulacaoProdutoResponse) => Promise<void>) => {
  const { t } = useTranslation('simulador')

  return useMutation({
    mutationKey: simulacaoKeys.salvar(),
    mutationFn: async (body: TSalvarSimulacaoBody) => {
      const response = await new CreateSimulacaoService().execute(body)
      return response.data
    },
    async onSuccess(response) {
      await onSuccess?.(response.data)
      showToast({
        message: t('salvar_simulacao.simulacao_salva.titulo'),
        variant: 'success',
        closeButton: true,
      })
    },
    onError() {
      showToast({
        message: t('salvar_simulacao.simulacao_nao_salva.titulo'),
        variant: 'error',
        closeButton: true,
      })
    },
  })
}
